import { request } from "#/utils/request";

export interface ICancelarProposta {
  codigoComissionado: string;
  documento: string;
  idDocumento: number;
}

interface ICancelarPropostaData {
  data: string;
  errors: ICancelarPropostaErrors;
}

interface ICancelarPropostaErrors {
  message: string;
  code: number;
}

/** Endpoints */
export const cancelarProposta = async ({
  codigoComissionado,
  documento,
  idDocumento,
}: ICancelarProposta) =>
  (
    await request.post<ICancelarPropostaData>(
      `/vendas/cancelar-proposta?idDocumento=${idDocumento}&codigoComissionado=${codigoComissionado}&documento=${documento}`,
      {
        cd_motivo_cancelamento: "007",
        ds_motivo_cancelamento: "OUTROS MOTIVOS",
      }
    )
  ).data;
